// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__v0uz+","site_name":"navbar_site_name__ylcHL","links":"navbar_links__1LTv-"};